"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return NcUpgrader;
    }
});
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _boxen = /*#__PURE__*/ _interop_require_default(require("boxen"));
const _0101002_ncAttachmentUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0101002_ncAttachmentUpgrader"));
const _0104002_ncAttachmentUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0104002_ncAttachmentUpgrader"));
const _0105002_ncStickyColumnUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0105002_ncStickyColumnUpgrader"));
const _0104004_ncFilterUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0104004_ncFilterUpgrader"));
const _0105003_ncFilterUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0105003_ncFilterUpgrader"));
const _0100002_ncFilterUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0100002_ncFilterUpgrader"));
const _0105004_ncHookUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0105004_ncHookUpgrader"));
const _0107004_ncProjectConfigUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0107004_ncProjectConfigUpgrader"));
const _0108002_ncXcdbLTARUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0108002_ncXcdbLTARUpgrader"));
const _0111002_ncXcdbLTARIndexUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0111002_ncXcdbLTARIndexUpgrader"));
const _0111005_ncXcdbCreatedAndUpdatedSystemFieldsUpgrader = /*#__PURE__*/ _interop_require_default(require("./upgraders/0111005_ncXcdbCreatedAndUpdatedSystemFieldsUpgrader"));
const _0225002_ncDatasourceDecrypt = /*#__PURE__*/ _interop_require_default(require("./upgraders/0225002_ncDatasourceDecrypt"));
const _0258003_ncDuplicatePluginMerge = /*#__PURE__*/ _interop_require_default(require("./upgraders/0258003_ncDuplicatePluginMerge"));
const _utils = require("~/utils");
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const log = (0, _debug.default)('nc:version-upgrader');
let NcUpgrader = class NcUpgrader {
    // Todo: transaction
    static async upgrade(ctx) {
        this.log(`upgrade :`);
        let oldVersion;
        try {
            var _ctx_ncMeta_knexConnection_schema_hasTable, _ctx_ncMeta_knexConnection_schema, _ctx_ncMeta_knexConnection;
            ctx.ncMeta = await ctx.ncMeta.startTransaction();
            if (!await ((_ctx_ncMeta_knexConnection = ctx.ncMeta.knexConnection) == null ? void 0 : (_ctx_ncMeta_knexConnection_schema = _ctx_ncMeta_knexConnection.schema) == null ? void 0 : (_ctx_ncMeta_knexConnection_schema_hasTable = _ctx_ncMeta_knexConnection_schema.hasTable) == null ? void 0 : _ctx_ncMeta_knexConnection_schema_hasTable.call(_ctx_ncMeta_knexConnection_schema, _globals.MetaTable.STORE))) {
                return;
            }
            this.log(`upgrade : Getting configuration from meta database`);
            const config = await ctx.ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
                key: this.STORE_KEY
            });
            const NC_VERSIONS = this.getUpgraderList();
            if (config) {
                const configObj = JSON.parse(config.value);
                if (configObj.version !== process.env.NC_VERSION) {
                    oldVersion = configObj.version;
                    for (const version of NC_VERSIONS){
                        // compare current version and old version
                        if (version.name > configObj.version) {
                            var _version_handler;
                            this.log(`upgrade : Upgrading '%s' => '%s'`, configObj.version, version.name);
                            await (version == null ? void 0 : (_version_handler = version.handler) == null ? void 0 : _version_handler.call(version, ctx));
                            // update version in meta after each upgrade
                            config.version = version.name;
                            await ctx.ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
                                value: JSON.stringify({
                                    version: config.version
                                })
                            }, {
                                key: NcUpgrader.STORE_KEY
                            });
                        // todo: backup data
                        }
                        if (version.name === process.env.NC_VERSION) {
                            break;
                        }
                    }
                    config.version = process.env.NC_VERSION;
                }
            } else {
                this.log(`upgrade : Inserting config to meta database`);
                const configObj = {};
                configObj.version = process.env.NC_VERSION;
                await ctx.ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
                    key: NcUpgrader.STORE_KEY,
                    value: JSON.stringify(configObj)
                }, true);
            }
            await ctx.ncMeta.commit();
            _utils.T.emit('evt', {
                evt_type: 'appMigration:upgraded',
                from: oldVersion,
                to: process.env.NC_VERSION
            });
        } catch (e) {
            var _e_stack_split, _e_stack;
            await ctx.ncMeta.rollback(e);
            _utils.T.emit('evt', {
                evt_type: 'appMigration:failed',
                from: oldVersion,
                to: process.env.NC_VERSION,
                msg: e.message,
                err: e == null ? void 0 : (_e_stack = e.stack) == null ? void 0 : (_e_stack_split = _e_stack.split) == null ? void 0 : _e_stack_split.call(_e_stack, '\n').slice(0, 2).join('\n')
            });
            console.log(getUpgradeErrorLog(e, oldVersion, process.env.NC_VERSION));
            throw e;
        }
    }
    static log(str, ...args) {
        log(`${str}`, ...args);
    }
    static getUpgraderList() {
        return [
            {
                name: '0100002',
                handler: _0100002_ncFilterUpgrader.default
            },
            {
                name: '0101002',
                handler: _0101002_ncAttachmentUpgrader.default
            },
            {
                name: '0104002',
                handler: _0104002_ncAttachmentUpgrader.default
            },
            {
                name: '0104004',
                handler: _0104004_ncFilterUpgrader.default
            },
            {
                name: '0105002',
                handler: _0105002_ncStickyColumnUpgrader.default
            },
            {
                name: '0105003',
                handler: _0105003_ncFilterUpgrader.default
            },
            {
                name: '0105004',
                handler: _0105004_ncHookUpgrader.default
            },
            {
                name: '0107004',
                handler: _0107004_ncProjectConfigUpgrader.default
            },
            {
                name: '0108002',
                handler: _0108002_ncXcdbLTARUpgrader.default
            },
            {
                name: '0111002',
                handler: _0111002_ncXcdbLTARIndexUpgrader.default
            },
            {
                name: '0111005',
                handler: _0111005_ncXcdbCreatedAndUpdatedSystemFieldsUpgrader.default
            },
            {
                name: '0225002',
                handler: _0225002_ncDatasourceDecrypt.default
            },
            {
                name: '0258003',
                handler: _0258003_ncDuplicatePluginMerge.default
            }
        ];
    }
};
NcUpgrader.STORE_KEY = 'NC_CONFIG_MAIN';
function getUpgradeErrorLog(e, oldVersion, newVersion) {
    const errorTitle = `Migration from ${oldVersion} to ${newVersion} failed`;
    return (0, _boxen.default)(`Error
-----
${e.stack}


Please raise an issue in our github by using following link : 
https://github.com/nocodb/nocodb/issues/new?labels=Type%3A%20Bug&template=bug_report.md

Or contact us in our Discord community by following link :
https://discord.gg/c7GEYrvFtT ( message @o1lab, @pranavxc or @wingkwong )`, {
        title: errorTitle,
        padding: 1,
        borderColor: 'yellow'
    });
}
